module.exports = __webpack_public_path__ + "img/investigate-module.a38f7067.png";